import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const makeRand = (l) => {
    // 生成する文字列に含める文字セット
    let c = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let cl = c.length;
    let r = "";
    for (let i = 0; i < l; i++) {
        r += c[Math.floor(Math.random() * cl)];
    }
    return r;
};
const index = new Vuex.Store({
    state: {
        user: null,
        status: false,
        endFirstAuth: false,
        values: {
            title: "ロケモシェア+",
            showMenuBar: true,
            imageRoot: "https://storage.googleapis.com/photosharemap.appspot.com/",
            apiRoot: process.env.NODE_ENV === 'production' ? 'https://locamo-ai.com/locamoshareplus/api/' : "http://localhost/project/photo-share-map/api/",
            rand: makeRand(5),
        },
        messages: [],
        tasks: 0,
        map: null
    },
    mutations: {
        onAuthStateChanged(state, user) {
            // state.user = user;
            if (!user) {
                state.user = null;
                return;
            }
            if (!state.user) {
                state.user = {};
            }
            let _user = {...state.user};
            for (let k in user) {
                _user[k] = user[k]; //firebaseが返したユーザー情報
            }
            state.user = _user;
        },
        onUserStatusChanged(state, status) {
            console.log("first auth");
            state.status = status; //ログインしてるかどうか true or false
            state.endFirstAuth = true;
        },
        updateUserName(state, name) {
            state.user.displayName = name;
        },
        set(state, status) {
            state.values[status.key] = status.val;
            if (status.key == "title") {
                state.values["showMenuBar"] = status.show ? false : true
            }
        },
        addMessage: (state, message) => {
            if (!message.dismissible) {
                message.dismissible = false;
            }
            if (!message.time) {
                message.time = 2.5;
            }
            if (message.risk !== 0 && !message.risk) {
                message.risk = 3;
            }
            state.messages.push(message);
        },
        removeMessage: (state) => {
            state.messages.shift();
        },
        addTask: (state) => {
            state.tasks++;
        },
        addMap: (state, map) => {
            state.map = {...map};
        },
        completeTask: (state) => {
            state.tasks--;
        }
    },
    getters: {
        user: state => {
            return state.user;
        },
        isSignedIn: state => {
            return state.status;
        },
        get: state => {
            return state.values;
        },
        endFirstAuth: state => {
            return state.endFirstAuth;
        },
        tasks: state => {
            return state.tasks;
        },
        getMessages: state => {
            return state.messages;
        },
        map: state => {
            return state.map;
        },
    },
});

export default index;
